export default class SelectLoadImg {
    constructor(elem) {
        this.elem = elem
        const src = elem.getAttribute("data-src");
        this.init(src).then();
    }

    async init(src) {
        try {
            const res = await fetch(src, {
                redirect: "error"
            });
            if (res.ok) {
                const text = await res.text();
                this.elem.src = src;
            } else {
                this.elem.src = src.replace(".jpg", ".png");
            }
        } catch (e) {
            this.elem.src = src.replace(".jpg", ".png");
        }
    }
}